/**
 * Session 21 — OCPP 2.0.1 ReservationStatusUpdate outbound (CP → CSMS).
 * Notifies the CSMS that a reservation changed WITHOUT a CancelReservation
 * — it expired, or the reserved connector was used by another idToken.
 * v2.0.1-only.
 */
export type ReservationUpdateStatus = 'Expired' | 'Removed';

export interface ReservationStatusUpdateDomain {
  readonly reservationId: number;
  readonly reservationUpdateStatus: ReservationUpdateStatus;
}

export function buildReservationStatusUpdateRequest(
  req: ReservationStatusUpdateDomain,
): Record<string, unknown> {
  return {
    reservationId: req.reservationId,
    reservationUpdateStatus: req.reservationUpdateStatus,
  };
}
